import React from "react";

function OurDivisions({ data }) {
  const handleClick = (item) => {
    if (item?.url) {
      window.open(item.url, "_blank");
    }
  };

  return (
      <div className="container">
        <div className="row">
          <div className="col-12">
          <div className="our-divison-wrapper">
            <div className="section-heading">
              <h2>Our Divisions</h2>
            </div>
            <div className="col-12">
              <div className="our-divison-content">
                {data?.map((item) => (
                  <figure
                    onClick={() => handleClick(item)}
                    className="our-divison-logo cursor-pointer"
                    key={item.division_id}
                  >
                    <img src={item.image} alt={item.image} />
                  </figure>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OurDivisions;
